'use strict';

var React = require('react');

var SvgChartHistogramFirstIcon = function SvgChartHistogramFirstIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4.25a.75.75 0 0 0-1.5 0v11.5a.75.75 0 0 0 1.5 0v-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.75a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0v-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 9.75a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0v-6Z"
  }));
};
SvgChartHistogramFirstIcon.displayName = "ChartHistogramFirstIcon";

exports.SvgChartHistogramFirstIcon = SvgChartHistogramFirstIcon;
